import React from "react";
import styled, { css } from "styled-components";
import "../../../sass/components/reuseable_components/_text-areas.scss";

// Aligns with src/sass/abstracts/_variables.scss ($breakpoints medium / large)
const BP_TABLET = 768;
const BP_DESKTOP = 1024;

/** WPGraphQL may return a string (legacy) or string[] (checkbox / multi-select). */
const normalizeDeviceSizes = (raw) => {
  if (raw == null) return ["mobile", "tablet", "desktop"];
  if (Array.isArray(raw) && raw.length === 0) return [];
  const list = Array.isArray(raw) ? raw : [raw];
  return list.map((s) => String(s).toLowerCase()).filter(Boolean);
};

const SpacerDiv = styled.div`
  ${(p) =>
    p.$applyMobile &&
    css`
      @media only screen and (max-width: ${BP_TABLET - 1}px) {
        padding-top: ${p.mobileMargins?.marginTop ?? 0}px;
        padding-bottom: ${p.mobileMargins?.marginBottom ?? 0}px;
      }
    `}

  ${(p) =>
    p.$applyTablet &&
    css`
      @media only screen and (min-width: ${BP_TABLET}px) and (max-width: ${BP_DESKTOP - 1}px) {
        padding-top: ${p.tabletMargins?.marginTop ?? 0}px;
        padding-bottom: ${p.tabletMargins?.marginBottom ?? 0}px;
      }
    `}

  ${(p) =>
    p.$applyDesktop &&
    css`
      @media only screen and (min-width: ${BP_DESKTOP}px) {
        padding-top: ${p.desktopMargins?.marginTop ?? 0}px !important;
        padding-bottom: ${p.desktopMargins?.marginBottom ?? 0}px !important;
      }
    `}
`;

const Spacer = (props) => {
  const { deviceSize, mobileMargins, tabletMargins, desktopMargins } = props.spacer ?? {
    deviceSize: props.deviceSize,
    mobileMargins: props.mobileMargins,
    tabletMargins: props.tabletMargins,
    desktopMargins: props.desktopMargins,
  };

  const sizes = normalizeDeviceSizes(deviceSize);

  return <SpacerDiv $applyMobile={sizes.includes("mobile")} $applyTablet={sizes.includes("tablet")} $applyDesktop={sizes.includes("desktop")} mobileMargins={mobileMargins} tabletMargins={tabletMargins} desktopMargins={desktopMargins} />;
};

export default Spacer;
